import type {SocialPost} from '@Components/social-media/post.vo';

export interface EnablePostMetricsResponse {
  post: SocialPost;
}

export enum SocialPostUserGuidelines {
  PERFORMANCE_LIMITATIONS = 'PERFORMANCE_LIMITATIONS',
  STORY_PERFORMANCE_LIMITATIONS = 'STORY_PERFORMANCE_LIMITATIONS',
  STORY_INSIGHTS_EXPIRED = 'STORY_INSIGHTS_EXPIRED',
  INSIGHTS_WINDOW_CLOSED = 'INSIGHTS_WINDOW_CLOSED',
  POPULATING = 'POPULATING',
  POPULATING_FRESH = 'POPULATING_FRESH',
  POPULATING_DELAYED = 'POPULATING_DELAYED',
  PARTIAL = 'PARTIAL',
  POST_DELETED_ON_PLATFORM = 'POST_DELETED_ON_PLATFORM',
  METRICS_TEMPORARILY_UNAVAILABLE = 'METRICS_TEMPORARILY_UNAVAILABLE',
  METRICS_UNAVAILABLE = 'METRICS_UNAVAILABLE',
  MIXED_UNAVAILABLE = 'MIXED_UNAVAILABLE',
  ERROR = 'ERROR',
  PRIVATE_POSTS = 'PRIVATE_POSTS',
  UPGRADE_PREMIUM = 'UPGRADE_PREMIUM',
  UNPUBLISHED_POST = 'UNPUBLISHED_POST',
  NO_GUIDELINES = 'NO_GUIDELINES',
  PERMISSION_PENDING = 'PERMISSION_PENDING',
}
